import { connect } from 'react-redux';

import api from '../../../REST/api';
import isPermitted from '../../../utils/is-permitted';
import {
  sendCancelInvoiceEmail as sendCancelInvoiceEmailAction,
  updateInvoice,
} from '../../actions/invoice-actions';
import UpdateInvoiceModal from './UpdateInvoiceModal';

const mapStateToProps = ({ balance }, { id }) => ({
  model: balance.invoices.find(invoice => invoice.id === id),
  bookingEntries: balance.bookingEntries,
});

const mapDispatchToProps = dispatch => ({
  onUpdate: (...args) => dispatch(updateInvoice(...args)),
  setStatus: (id, status, message) => {
    return dispatch(updateInvoice(id, { status, requestedChanges: message }));
  },
  sendCancelInvoiceEmail: (id, cancellationReason) => {
    return dispatch(sendCancelInvoiceEmailAction(id, cancellationReason));
  },
});

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...stateProps,
  ...dispatchProps,
  ...ownProps,
  hasPermissionToUpdateStatus: isPermitted(api.patchInvoice),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps,
)(UpdateInvoiceModal);
